"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH_USER_HOLDING_VIEW = void 0;
const client_1 = require("@apollo/client");
exports.SWITCH_USER_HOLDING_VIEW = client_1.gql `
  mutation switchHoldingView($input: InputSwitchHoldingView!) {
    switchHoldingView(input: $input) {
      id
    }
  }
`;
